import { render } from "./PhotoDetailModal.vue?vue&type=template&id=2763ab05&scoped=true"
import script from "./PhotoDetailModal.vue?vue&type=script&lang=js"
export * from "./PhotoDetailModal.vue?vue&type=script&lang=js"

import "./PhotoDetailModal.vue?vue&type=style&index=0&id=2763ab05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2763ab05"]])

export default __exports__